// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: tournament/model/TournamentPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ModifiersPayload } from "../../common/model/ModifiersPt";
import {
  FightSportPayload,
  fightSportPayloadFromJSON,
  fightSportPayloadToJSON,
} from "../../fight/model/enums/FightSportPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.tournament.model";

/** 대회 상태 */
export enum TournamentStatusPayload {
  TOURNAMENT_STATUS_UNKNOWN = 0,
  /** TOURNAMENT_SCHEDULED - 접수 예정 (entryOpenAt 이전) */
  TOURNAMENT_SCHEDULED = 1,
  /** TOURNAMENT_ENTRY_OPEN - 접수 중 */
  TOURNAMENT_ENTRY_OPEN = 2,
  /** TOURNAMENT_ENTRY_CLOSED - 접수 마감 */
  TOURNAMENT_ENTRY_CLOSED = 3,
  /** TOURNAMENT_ONGOING - 대회 진행 중 */
  TOURNAMENT_ONGOING = 4,
  /** TOURNAMENT_FINISHED - 종료 */
  TOURNAMENT_FINISHED = 5,
  /** TOURNAMENT_CANCELED - 취소 */
  TOURNAMENT_CANCELED = 6,
  UNRECOGNIZED = -1,
}

export function tournamentStatusPayloadFromJSON(object: any): TournamentStatusPayload {
  switch (object) {
    case 0:
    case "TOURNAMENT_STATUS_UNKNOWN":
      return TournamentStatusPayload.TOURNAMENT_STATUS_UNKNOWN;
    case 1:
    case "TOURNAMENT_SCHEDULED":
      return TournamentStatusPayload.TOURNAMENT_SCHEDULED;
    case 2:
    case "TOURNAMENT_ENTRY_OPEN":
      return TournamentStatusPayload.TOURNAMENT_ENTRY_OPEN;
    case 3:
    case "TOURNAMENT_ENTRY_CLOSED":
      return TournamentStatusPayload.TOURNAMENT_ENTRY_CLOSED;
    case 4:
    case "TOURNAMENT_ONGOING":
      return TournamentStatusPayload.TOURNAMENT_ONGOING;
    case 5:
    case "TOURNAMENT_FINISHED":
      return TournamentStatusPayload.TOURNAMENT_FINISHED;
    case 6:
    case "TOURNAMENT_CANCELED":
      return TournamentStatusPayload.TOURNAMENT_CANCELED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TournamentStatusPayload.UNRECOGNIZED;
  }
}

export function tournamentStatusPayloadToJSON(object: TournamentStatusPayload): string {
  switch (object) {
    case TournamentStatusPayload.TOURNAMENT_STATUS_UNKNOWN:
      return "TOURNAMENT_STATUS_UNKNOWN";
    case TournamentStatusPayload.TOURNAMENT_SCHEDULED:
      return "TOURNAMENT_SCHEDULED";
    case TournamentStatusPayload.TOURNAMENT_ENTRY_OPEN:
      return "TOURNAMENT_ENTRY_OPEN";
    case TournamentStatusPayload.TOURNAMENT_ENTRY_CLOSED:
      return "TOURNAMENT_ENTRY_CLOSED";
    case TournamentStatusPayload.TOURNAMENT_ONGOING:
      return "TOURNAMENT_ONGOING";
    case TournamentStatusPayload.TOURNAMENT_FINISHED:
      return "TOURNAMENT_FINISHED";
    case TournamentStatusPayload.TOURNAMENT_CANCELED:
      return "TOURNAMENT_CANCELED";
    case TournamentStatusPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** 대회 Payload (TB_TOURNAMENT 과 1:1) */
export interface TournamentPayload {
  /** 고유 id */
  id: string;
  /** 대회명 */
  name: string;
  /** 대회 시작일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  startAt: string;
  /** 대회 종료일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  endAt: string;
  /** 개최 장소 */
  venue: string;
  /** 참가 접수 시작일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  entryOpenAt: string;
  /** 참가 접수 마감일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  entryCloseAt: string;
  /** 개최 종목 (참가 신청 폼의 종목 선택 목록이 된다) */
  sport: FightSportPayload[];
  /** 대회 상태 */
  status: TournamentStatusPayload;
  /** 수정 정보 */
  modifiers:
    | ModifiersPayload
    | undefined;
  /** 안내사항 (대회 상세 화면에 그대로 노출한다. HTML 이 실려도 서버는 저장만 하고 출력 sanitize 는 프론트가 한다) */
  notice: string;
}

/** 대회 목록 한 줄 (목록에 본문 · 안내사항까지 실어 보내지 않는다) */
export interface TournamentSummaryPayload {
  /** 고유 id */
  id: string;
  /** 대회명 */
  name: string;
  /** 대회 시작일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  startAt: string;
  /** 대회 종료일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  endAt: string;
  /** 개최 장소 */
  venue: string;
  /** 참가 접수 시작일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  entryOpenAt: string;
  /** 참가 접수 마감일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  entryCloseAt: string;
  /** 개최 종목 */
  sport: FightSportPayload[];
  /** 대회 상태 */
  status: TournamentStatusPayload;
  /** 접수된 신청 건수 (관리자 목록에서 쓴다. 공개 목록은 0) */
  entryCount: number;
}

/** 대회 검색 조건 (빈 값 · UNKNOWN 은 「전체」다) */
export interface TournamentSearchConditionPayload {
  /** 대회명 검색어 */
  name: string;
  /** 상태 필터 */
  status: TournamentStatusPayload;
  /** 개최 종목 필터 */
  sport: FightSportPayload;
}

function createBaseTournamentPayload(): TournamentPayload {
  return {
    id: "",
    name: "",
    startAt: "",
    endAt: "",
    venue: "",
    entryOpenAt: "",
    entryCloseAt: "",
    sport: [],
    status: 0,
    modifiers: undefined,
    notice: "",
  };
}

export const TournamentPayload: MessageFns<TournamentPayload> = {
  encode(message: TournamentPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.startAt !== "") {
      writer.uint32(26).string(message.startAt);
    }
    if (message.endAt !== "") {
      writer.uint32(34).string(message.endAt);
    }
    if (message.venue !== "") {
      writer.uint32(42).string(message.venue);
    }
    if (message.entryOpenAt !== "") {
      writer.uint32(50).string(message.entryOpenAt);
    }
    if (message.entryCloseAt !== "") {
      writer.uint32(58).string(message.entryCloseAt);
    }
    writer.uint32(66).fork();
    for (const v of message.sport) {
      writer.int32(v);
    }
    writer.join();
    if (message.status !== 0) {
      writer.uint32(72).int32(message.status);
    }
    if (message.modifiers !== undefined) {
      ModifiersPayload.encode(message.modifiers, writer.uint32(82).fork()).join();
    }
    if (message.notice !== "") {
      writer.uint32(90).string(message.notice);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startAt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.venue = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.entryOpenAt = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.entryCloseAt = reader.string();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.sport.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sport.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.modifiers = ModifiersPayload.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.notice = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      startAt: isSet(object.startAt) ? globalThis.String(object.startAt) : "",
      endAt: isSet(object.endAt) ? globalThis.String(object.endAt) : "",
      venue: isSet(object.venue) ? globalThis.String(object.venue) : "",
      entryOpenAt: isSet(object.entryOpenAt) ? globalThis.String(object.entryOpenAt) : "",
      entryCloseAt: isSet(object.entryCloseAt) ? globalThis.String(object.entryCloseAt) : "",
      sport: globalThis.Array.isArray(object?.sport) ? object.sport.map((e: any) => fightSportPayloadFromJSON(e)) : [],
      status: isSet(object.status) ? tournamentStatusPayloadFromJSON(object.status) : 0,
      modifiers: isSet(object.modifiers) ? ModifiersPayload.fromJSON(object.modifiers) : undefined,
      notice: isSet(object.notice) ? globalThis.String(object.notice) : "",
    };
  },

  toJSON(message: TournamentPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.startAt !== "") {
      obj.startAt = message.startAt;
    }
    if (message.endAt !== "") {
      obj.endAt = message.endAt;
    }
    if (message.venue !== "") {
      obj.venue = message.venue;
    }
    if (message.entryOpenAt !== "") {
      obj.entryOpenAt = message.entryOpenAt;
    }
    if (message.entryCloseAt !== "") {
      obj.entryCloseAt = message.entryCloseAt;
    }
    if (message.sport?.length) {
      obj.sport = message.sport.map((e) => fightSportPayloadToJSON(e));
    }
    if (message.status !== 0) {
      obj.status = tournamentStatusPayloadToJSON(message.status);
    }
    if (message.modifiers !== undefined) {
      obj.modifiers = ModifiersPayload.toJSON(message.modifiers);
    }
    if (message.notice !== "") {
      obj.notice = message.notice;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentPayload>, I>>(base?: I): TournamentPayload {
    return TournamentPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentPayload>, I>>(object: I): TournamentPayload {
    const message = createBaseTournamentPayload();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.startAt = object.startAt ?? "";
    message.endAt = object.endAt ?? "";
    message.venue = object.venue ?? "";
    message.entryOpenAt = object.entryOpenAt ?? "";
    message.entryCloseAt = object.entryCloseAt ?? "";
    message.sport = object.sport?.map((e) => e) || [];
    message.status = object.status ?? 0;
    message.modifiers = (object.modifiers !== undefined && object.modifiers !== null)
      ? ModifiersPayload.fromPartial(object.modifiers)
      : undefined;
    message.notice = object.notice ?? "";
    return message;
  },
};

function createBaseTournamentSummaryPayload(): TournamentSummaryPayload {
  return {
    id: "",
    name: "",
    startAt: "",
    endAt: "",
    venue: "",
    entryOpenAt: "",
    entryCloseAt: "",
    sport: [],
    status: 0,
    entryCount: 0,
  };
}

export const TournamentSummaryPayload: MessageFns<TournamentSummaryPayload> = {
  encode(message: TournamentSummaryPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.startAt !== "") {
      writer.uint32(26).string(message.startAt);
    }
    if (message.endAt !== "") {
      writer.uint32(34).string(message.endAt);
    }
    if (message.venue !== "") {
      writer.uint32(42).string(message.venue);
    }
    if (message.entryOpenAt !== "") {
      writer.uint32(50).string(message.entryOpenAt);
    }
    if (message.entryCloseAt !== "") {
      writer.uint32(58).string(message.entryCloseAt);
    }
    writer.uint32(66).fork();
    for (const v of message.sport) {
      writer.int32(v);
    }
    writer.join();
    if (message.status !== 0) {
      writer.uint32(72).int32(message.status);
    }
    if (message.entryCount !== 0) {
      writer.uint32(80).int32(message.entryCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentSummaryPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentSummaryPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startAt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.venue = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.entryOpenAt = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.entryCloseAt = reader.string();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.sport.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sport.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.entryCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentSummaryPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      startAt: isSet(object.startAt) ? globalThis.String(object.startAt) : "",
      endAt: isSet(object.endAt) ? globalThis.String(object.endAt) : "",
      venue: isSet(object.venue) ? globalThis.String(object.venue) : "",
      entryOpenAt: isSet(object.entryOpenAt) ? globalThis.String(object.entryOpenAt) : "",
      entryCloseAt: isSet(object.entryCloseAt) ? globalThis.String(object.entryCloseAt) : "",
      sport: globalThis.Array.isArray(object?.sport) ? object.sport.map((e: any) => fightSportPayloadFromJSON(e)) : [],
      status: isSet(object.status) ? tournamentStatusPayloadFromJSON(object.status) : 0,
      entryCount: isSet(object.entryCount) ? globalThis.Number(object.entryCount) : 0,
    };
  },

  toJSON(message: TournamentSummaryPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.startAt !== "") {
      obj.startAt = message.startAt;
    }
    if (message.endAt !== "") {
      obj.endAt = message.endAt;
    }
    if (message.venue !== "") {
      obj.venue = message.venue;
    }
    if (message.entryOpenAt !== "") {
      obj.entryOpenAt = message.entryOpenAt;
    }
    if (message.entryCloseAt !== "") {
      obj.entryCloseAt = message.entryCloseAt;
    }
    if (message.sport?.length) {
      obj.sport = message.sport.map((e) => fightSportPayloadToJSON(e));
    }
    if (message.status !== 0) {
      obj.status = tournamentStatusPayloadToJSON(message.status);
    }
    if (message.entryCount !== 0) {
      obj.entryCount = Math.round(message.entryCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentSummaryPayload>, I>>(base?: I): TournamentSummaryPayload {
    return TournamentSummaryPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentSummaryPayload>, I>>(object: I): TournamentSummaryPayload {
    const message = createBaseTournamentSummaryPayload();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.startAt = object.startAt ?? "";
    message.endAt = object.endAt ?? "";
    message.venue = object.venue ?? "";
    message.entryOpenAt = object.entryOpenAt ?? "";
    message.entryCloseAt = object.entryCloseAt ?? "";
    message.sport = object.sport?.map((e) => e) || [];
    message.status = object.status ?? 0;
    message.entryCount = object.entryCount ?? 0;
    return message;
  },
};

function createBaseTournamentSearchConditionPayload(): TournamentSearchConditionPayload {
  return { name: "", status: 0, sport: 0 };
}

export const TournamentSearchConditionPayload: MessageFns<TournamentSearchConditionPayload> = {
  encode(message: TournamentSearchConditionPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.sport !== 0) {
      writer.uint32(24).int32(message.sport);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentSearchConditionPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentSearchConditionPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentSearchConditionPayload {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? tournamentStatusPayloadFromJSON(object.status) : 0,
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: TournamentSearchConditionPayload): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== 0) {
      obj.status = tournamentStatusPayloadToJSON(message.status);
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentSearchConditionPayload>, I>>(
    base?: I,
  ): TournamentSearchConditionPayload {
    return TournamentSearchConditionPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentSearchConditionPayload>, I>>(
    object: I,
  ): TournamentSearchConditionPayload {
    const message = createBaseTournamentSearchConditionPayload();
    message.name = object.name ?? "";
    message.status = object.status ?? 0;
    message.sport = object.sport ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
